import { observable } from 'mobx';
import moment from 'moment';
import AuthComponent from '../../login/component/auth-provider';
import { AppConstants } from '../../../common/APIConstants';
import PLMAlarmDataService from '../services/plm-alarm-data-services';
import segDef from '../component/segment-def.json'
import stnDef from '../component/station-def.json'

class PLMAlarmDataStore {
    @observable rowDataStn = []
    @observable rowDataSeg = []
    @observable segColDef = []
    @observable stnColDef = []
    @observable plmRole = null

    getGridData = async (currentScreen, weekSelected) => {
        let stnData = []
        let segData = []
        try {
            const { data } = await PLMAlarmDataService.getGridData(currentScreen);
            if (data?.length > 0) {
                stnData = data.filter(row => row.Type === 'Station')
                segData = data.filter(row => row.Type === 'Segment')
            }
            this.segColDef = this.getCustomColDef(segDef, weekSelected)
            this.stnColDef = this.getCustomColDef(stnDef, weekSelected)
            this.rowDataStn = stnData
            this.rowDataSeg = segData
        } catch (error) {
            window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
        }
    };

    saveRowData = async (currentScreen, data) => {
        const updateScreen = Object.assign({}, currentScreen)
        updateScreen.data = data
        try {
            await PLMAlarmDataService.updateData(updateScreen)
                .then(function () { window.toastr.success(AppConstants.TOASTER_SUCCESS) })
        } catch (err) {
            console.error(err)
            const errMsg = err?.response?.data || AppConstants.TOASTER_ERROR_SAVE_TEXT
            window.toastr.error(errMsg)
        }
    }

    getDateTimeLock = (weekSelected, flag) => {
        const nonEditableStyle = "cell-wrap-text ag-non-editable-col-plm"
        const editableStyle = "cell-wrap-text"
        const now = moment().tz(AppConstants.MT_TIME_FORMATTER);
        const selectedWeek = moment(weekSelected).week()
        const day = now.day()
        const hour = now.hour()
        const lastWeek = moment(new Date()).subtract(7, 'd').week()

        // selected week does not match previous of current week 
        if (selectedWeek !== lastWeek) {
            return flag === 'edit' ? false : nonEditableStyle
        }
        // selected week matches previous week & current week has Thursday day and hour 4PM or more
        if ((selectedWeek === lastWeek) && day === 4 && hour >= 16) {
            return flag === 'edit' ? false : nonEditableStyle
        }
        // selected week matches previous week & current week has Thursday day or greater day
        if ((selectedWeek === lastWeek) && day > 4) {
            return flag === 'edit' ? false : nonEditableStyle
        }
        return flag === 'edit' ? true : editableStyle
    }

    getCustomColDef = (colDefs, weekSelected) => {
        const colDef = colDefs.map(item => {
            if (item.field === 'UpdatedOn') {
                item.valueGetter = (p) => {
                    if (p?.data?.UpdatedOn)
                        return p.data.UpdatedOn.replace(',', ' ')
                }
            }
            if (item.headerName === 'PLM Segment Alarms' || item.headerName === 'PLM Station Alarms') {
                const children = item.children
                const commentIndex = children.findIndex(idx => idx.field === 'Comments')
                children[commentIndex].editable = (p) => {
                    if (this.plmRole === null || this.plmRole === 'PlmOPS') {
                        return false
                    }
                    return this.getDateTimeLock(weekSelected, 'edit')
                }
                children[commentIndex].cellClass = (p) => {
                    if (this.plmRole === null || this.plmRole === 'PlmOPS') {
                        return "cell-wrap-text ag-non-editable-col-plm"
                    }
                    return this.getDateTimeLock(weekSelected, 'style')
                }
                item.children = children
            }
            return item
        })
        return colDef
    }

    getUserRole = async () => {
        this.plmRole = await AuthComponent.getUserNamePostLogin().then((response) => {
            if (response.roles.some(item => "PLMAlarmControlCentre" === item)) {
                return 'PlmCC';
            }
            else if (response.roles.some(item => "PLMAlarmOpsLeaders" === item)) {
                return 'PlmOPS';
            }
            return null
        });
    }
}

export default new PLMAlarmDataStore()